// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../../../../node_modules/rescript/lib/es6/array.js";
import * as Caml_obj from "../../../../../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Timestamp$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as BinarySearchUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/BinarySearchUtils.bs.js";

function splitRoute(timestamp, input) {
  var comparator = function (x, y) {
    if (Caml_obj.caml_equal(x, y)) {
      return 0;
    } else if (Timestamp$Catalyst.isBefore(x, y)) {
      return 1;
    } else {
      return -1;
    }
  };
  var value = BinarySearchUtils$Catalyst.binarySearch(timestamp, $$Array.map((function (x) {
              return x.ts;
            }), input), 0, input.length, comparator);
  if (value.TAG === /* Ok */0) {
    return value._0[0];
  } else if (value._0) {
    return input.length - 1 | 0;
  } else {
    return 0;
  }
}

export {
  splitRoute ,
  
}
/* Timestamp-Catalyst Not a pure module */
